var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPayPass = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 24,
  fill: "none",
  viewBox: "0 0 20 24",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2.571,
  d: "M15.143 1.286a21.43 21.43 0 0 1 0 21.428M10.429 3.643a16.71 16.71 0 0 1 0 16.714m-4.5-14.55a12.3 12.3 0 0 1 1.619 6.107c0 2.144-.559 4.25-1.62 6.107m-4.5-9.878A7 7 0 0 1 2.599 12a7 7 0 0 1-1.17 3.857"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v24H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPayPass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/payPass.2d35e8ee5feeed98715ff35545f7a86b.svg";